import React, { FC, memo } from "react";
import { Icon, Slider } from "@evergis/ui";

import { LayerOpacityContainer, LayerOpacityValue, SliderContainer } from "./styled";

import { useProjectLayerOpacity } from "../../../../hooks/project/useProjectLayerOpacity";

import { LayerOpacityProps } from "./types";

export const LayerOpacity: FC<LayerOpacityProps> = memo(({ layerName, opacity: opacityProp }) => {
  const { opacity, onChange, onStop } = useProjectLayerOpacity(layerName, opacityProp);

  return (
    <LayerOpacityContainer onClick={e => e.stopPropagation()}>
      <Icon kind={"transparentize"} />
      <SliderContainer>
        <Slider value={opacity} showTooltips primary onChange={onChange} onStop={onStop} min={0} max={100} />
      </SliderContainer>
      <LayerOpacityValue>{opacity}</LayerOpacityValue>
    </LayerOpacityContainer>
  );
});
